import { QueryClient } from "@tanstack/react-query";

/** Cache largo: no volver a pedir datos al salir y entrar a la misma página. Invalidamos en mutaciones. */
const STALE_TIME_MS = 10 * 60 * 1000; // 10 minutos

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      refetchOnWindowFocus: false,
    },
  },
});
